import React from 'react';
import { ClockIcon, DollarSignIcon, HardHatIcon, ListChecksIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const reasons = [{
  icon: HardHatIcon,
  titleKey: 'why.craft.title',
  descKey: 'why.craft.desc'
}, {
  icon: ClockIcon,
  titleKey: 'why.fast.title',
  descKey: 'why.fast.desc'
}, {
  icon: DollarSignIcon,
  titleKey: 'why.price.title',
  descKey: 'why.price.desc'
}, {
  icon: ListChecksIcon,
  titleKey: 'why.pm.title',
  descKey: 'why.pm.desc'
}];
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-322" data-mp="78r9u5gbxiib">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-323" data-mp="b7rrvlqzgh49">
        <Reveal data-id="element-324" data-mp="bacsy8jgit0y">
          <SectionHeading eyebrow={t('why.eyebrow')} title={t('why.title')} data-id="element-325" data-mp="21l8tz45vg2iq" />
        </Reveal>

        <ul className="mt-12 grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-326" data-mp="25maurpffsmmt">
          {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return <Reveal key={reason.titleKey} as="li" delay={index * 0.06} data-id="element-327" data-mp="1iftt33zfg4io" data-mpi={index}>
                <div className="flex h-full flex-col border-t-2 border-amber-600 pt-5" data-id="element-328" data-mp="1idpt2x4nfpno">
                  <Icon className="h-7 w-7 text-navy-900" strokeWidth={2} aria-hidden="true" data-id="element-329" data-mp="1x6j8kijx85sc" />
                  <h3 className="mt-4 font-display text-lg font-extrabold leading-snug text-navy-900" data-id="element-330" data-mp="1s658pnsh425e">
                    {t(reason.titleKey)}
                  </h3>
                  <p className="mt-2.5 text-[15px] leading-relaxed text-navy-900/70" data-id="element-331" data-mp="zhrcndky3fwh">
                    {t(reason.descKey)}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}